import { animate, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SidebarActionButtons } from '../../models/sidebar-action-buttons.model';
import { ButtonTypeEnum } from '../../enums/button-type.enum';
import { ColorTypeEnum } from '../../enums/color-type.enum';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    animations: [
        trigger('sidebarAnimation', [
            transition(':enter', [
                style([{ transform: 'translateX(100%)' }]),
                animate('0.5s ease-in-out', style([{ transform: 'translateX(0%)' }])),
            ]),
            transition(':leave', [
                style([{ transform: 'translateX(0%)' }]),
                animate('0.5s ease-in-out', style([{ transform: 'translateX(100%)' }])),
            ])
        ])
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SidebarComponent implements AfterViewInit {

  @Input() public title: string;
  @Input() public show: boolean;
  @Input() public blockAutomaticCssSetting: boolean;
  @Input() public actionButtons: SidebarActionButtons[];

  @Output() public clickButton = new EventEmitter<SidebarActionButtons>();
  @Output() public close = new EventEmitter<any>();

  public buttonTypeEnum = ButtonTypeEnum;
  public colorTypeEnum = ColorTypeEnum;

  public sidebarContentId = 'sidebar-content-id';

  private animationTime = 500;

  constructor() {
    this.show = true;
  }

  public ngAfterViewInit() {
    const el = document.getElementById(this.sidebarContentId);
    if (el && !this.blockAutomaticCssSetting) { el.firstElementChild.classList.add('flex', 'column', 'full-height'); }
  }

  public onClose() {
    this.show = false;
    setTimeout(() => {
      this.close.emit();
    }, this.animationTime);
  }

  public onClickButton(button: SidebarActionButtons) {
    this.clickButton.emit(button);
  }
}
